import * as React from 'react';
// import PropTypes from 'prop-types';

import * as styles from './styles.sass';

const noop = () => null;
interface OutsideClickContainerProps {
  children: React.ReactNode;
  onClickOutside: () => void;
}

const defaultProps = {
  onClickOutside: noop,
};

interface OutsideClickContainerState {}

class OutsideClickContainer extends React.Component<
  OutsideClickContainerProps,
  OutsideClickContainerState
> {
  public static defaultProps = defaultProps;
  private outsideWrapper?: HTMLDivElement;
  constructor(props: OutsideClickContainerProps) {
    super(props);
  }

  public componentDidMount = () => {
    document.addEventListener('mousedown', this.handleClickOutside);
  };

  public componentWillUnmount = () => {
    document.removeEventListener('mousedown', this.handleClickOutside);
  };

  public setWrapperRef = (node: HTMLDivElement): void => {
    this.outsideWrapper = node as any; // TODO: Do not use any here
  };

  public handleClickOutside: EventListener = e => {
    const { onClickOutside } = this.props;
    if (
      this.outsideWrapper &&
      e.target &&
      !this.outsideWrapper.contains(e.target as HTMLDivElement)
    ) {
      onClickOutside();
    }
  };

  public render() {
    const { children } = this.props;
    return (
      <div ref={this.setWrapperRef} className={styles.wrapper}>
        {children}
      </div>
    );
  }
}

export { OutsideClickContainer };
